import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import MerchantLayout from "../../layout/MerchantLayout";
import { SubscriptionInfo, UserInfo } from "../../../context";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantOrders from "./order";
import MerchantTabDineSetup from "./dine-setup";
import axios from "axios";

const MerchantTabOrders = () => {
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();
  const [dineTypeList, setDineTypeList] = useState({
    data: [],
    ready: false,
  });

  const items = [
    {
      key: "1",
      label: `Orders`,
      children: (
        <MerchantOrders
          dineTypeList={dineTypeList.ready && dineTypeList.data.length > 0}
          allowDineSetup={
            userData.data.usersmerpermission.find(
              ({ permission }) => permission === "allow-dine-setup"
            )
              ? true
              : false
          }
        />
      ),
    },
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-dine-setup"
    )
      ? {
          key: "2",
          label: `Dine Setup`,
          children: (
            <MerchantTabDineSetup
              dineTypeList={dineTypeList}
              rerun={() => {
                getDineTypeList();
              }}
            />
          ),
        }
      : null,
  ];

  const getDineTypeList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/dine-list", { params })
      .then((response) => {
        const data = response.data;
        setDineTypeList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getDineTypeList();
  }, [getDineTypeList]);

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantTabOrders;
